import React from "react";
import {Container} from "react-bootstrap";
import {getAppData} from "../../../services/AdminService";
import {AdminEditAppModal} from "./AdminEditAppModal";

export const AdminApp = () => {

    const [app, setApp] = React.useState({});
    const [edit, setEdit] = React.useState(false);

    const fetchAppData = React.useCallback(async () => {


        try {
            const values = await getAppData();
            setApp(values);
        } catch (e) {
            console.error(e)
        }

    }, []);

    React.useEffect(() => {
        console.log(edit)
        fetchAppData();
    }, []);

    return (

        <Container>
            <Container className={"leadsGrid"}>
                Leadtub Appen: version {app.version}


            </Container>



            <AdminEditAppModal version={app.version}/>
        </Container>
    )
}
